import React, { useState, useEffect } from 'react';
import axios from 'axios';

const fmt = (n) => n ? Number(n).toLocaleString('tr-TR') : '0';
const fmtTarih = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

const AYLAR = ['', 'Oca', 'Sub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Agu', 'Eyl', 'Eki', 'Kas', 'Ara'];

const StatKart = ({ baslik, deger, renk, alt }) => (
  <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '1rem 1.25rem' }}>
    <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>{baslik}</div>
    <div style={{ fontSize: '22px', fontWeight: '700', color: renk || '#111827' }}>{deger}</div>
    {alt && <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '2px' }}>{alt}</div>}
  </div>
);

const Bolum = ({ baslik, children }) => (
  <div style={{ marginBottom: '2rem' }}>
    <div style={{ fontSize: '13px', fontWeight: '600', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '1rem', paddingBottom: '6px', borderBottom: '1px solid #F3F4F6' }}>
      {baslik}
    </div>
    {children}
  </div>
);

const IsealimRaporuPage = () => {
  const [veri, setVeri] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [seciliYil, setSeciliYil] = useState(new Date().getFullYear());
  const [aktifSekme, setAktifSekme] = useState('ozet');

  const yukle = (yil) => {
    setYukleniyor(true);
    axios.get('/api/isealim-rapor?yil=' + yil)
      .then(r => { setVeri(r.data); setYukleniyor(false); })
      .catch(() => setYukleniyor(false));
  };

  useEffect(() => { yukle(seciliYil); }, [seciliYil]);

  if (yukleniyor) return <div style={{ padding: '3rem', textAlign: 'center', color: '#6B7280' }}>Yukleniyor...</div>;
  if (!veri) return <div style={{ padding: '2rem', color: '#DC2626' }}>Veri yuklenemedi.</div>;

  const { ozet, aylik_ozet, musteri_ozet, pipeline, adaylar, yillar } = veri;

  return (
    <div>
      <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h2 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '4px' }}>Ise Alim Raporu</h2>
          <p style={{ fontSize: '13px', color: '#6B7280' }}>Aday sureci ve issealim performans analizi</p>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <select value={seciliYil} onChange={e => setSeciliYil(e.target.value)}
            style={{ padding: '8px 12px', border: '1px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', fontWeight: '600' }}>
            {(yillar || []).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button onClick={() => (() => { const t = localStorage.getItem('token'); fetch('/api/pdf-rapor/isealim?yil=' + seciliYil, {headers:{Authorization:'Bearer '+t}}).then(r=>r.blob()).then(b=>{const a=document.createElement('a');a.href=URL.createObjectURL(b);a.download='isealim-raporu.pdf';a.click()}); })()}
            style={{ padding: '8px 16px', border: 'none', borderRadius: '8px', background: '#DC2626', color: '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
            PDF Indir
          </button>
        </div>
      </div>

      {/* Genel Özet */}
      <Bolum baslik={ozet.yil + ' Yili Ozet'}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
          <StatKart baslik="Toplam Aday" deger={ozet.toplam_aday} />
          <StatKart baslik="Tamamlanan" deger={ozet.tamamlanan} renk="#059669" />
          <StatKart baslik="Devam Eden" deger={ozet.devam_eden} renk="#1a56db" />
          <StatKart baslik="Elenen" deger={ozet.elenen} renk="#DC2626" />
          <StatKart baslik="Donusum Orani" deger={ozet.donusum_orani + '%'} renk={ozet.donusum_orani >= 30 ? '#059669' : '#F59E0B'} />
          <StatKart baslik="Elenme Orani" deger={ozet.elenme_orani + '%'} renk="#DC2626" />
          <StatKart baslik="Ort. Hiring Suresi" deger={ozet.ort_hiring_suresi + ' gun'} renk="#1a56db" />
        </div>

        {/* Pipeline */}
        <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '1.25rem' }}>
          <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '1rem' }}>Guncel Pipeline</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '8px' }}>
            {[
              { label: 'Yeni', deger: pipeline.yeni, renk: '#6B7280' },
              { label: 'Tel. Bekleme', deger: pipeline.telefon_bekleme, renk: '#F59E0B' },
              { label: 'Mus. Bekleme', deger: pipeline.musteri_bekleme, renk: '#1a56db' },
              { label: 'Teklif Sureci', deger: pipeline.teklif_sureci, renk: '#7C3AED' },
              { label: 'Tamamlandi', deger: pipeline.tamamlandi, renk: '#059669' },
              { label: 'Elendi', deger: pipeline.elendi, renk: '#DC2626' },
            ].map((item, i) => (
              <div key={i} style={{ background: '#F9FAFB', borderRadius: '8px', padding: '12px', textAlign: 'center', borderTop: '3px solid ' + item.renk }}>
                <div style={{ fontSize: '22px', fontWeight: '700', color: item.renk }}>{item.deger || 0}</div>
                <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '2px' }}>{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </Bolum>

      {/* Sekmeler */}
      <div style={{ display: 'flex', borderBottom: '1px solid #E5E7EB', marginBottom: '1.5rem', gap: '0' }}>
        {[['ozet','Aylik Dagilim'],['musteri','Musteri Bazli'],['adaylar','Aday Listesi']].map(([k,l]) => (
          <button key={k} onClick={() => setAktifSekme(k)}
            style={{ padding: '10px 20px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: aktifSekme === k ? '600' : '400', color: aktifSekme === k ? '#1a56db' : '#6B7280', borderBottom: aktifSekme === k ? '2px solid #1a56db' : '2px solid transparent' }}>
            {l}
          </button>
        ))}
      </div>

      {/* Aylık Dağılım */}
      {aktifSekme === 'ozet' && (
        <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
          {aylik_ozet.length === 0 ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: '#6B7280' }}>Bu yil icin veri bulunamadi</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Ay</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Toplam</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Tamamlanan</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Elenen</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Devam</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Donusum %</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Ort. Hiring</th>
                  </tr>
                </thead>
                <tbody>
                  {aylik_ozet.map((a, i) => {
                    const ayNo = a.ay ? parseInt(a.ay.split('-')[1]) : null;
                    const ayLabel = ayNo ? AYLAR[ayNo] + ' ' + a.ay.split('-')[0] : a.ay;
                    return (
                      <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                        <td style={{ padding: '10px 16px', fontWeight: '500' }}>{ayLabel}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'right' }}>{a.toplam}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'right', color: '#059669', fontWeight: '600' }}>{a.tamamlanan}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'right', color: '#DC2626' }}>{a.elenen}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'right', color: '#1a56db' }}>{a.devam}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'right' }}>
                          <span style={{ background: a.donusum_orani >= 30 ? '#D1FAE5' : '#FEF3C7', color: a.donusum_orani >= 30 ? '#059669' : '#D97706', padding: '2px 8px', borderRadius: '99px', fontSize: '12px', fontWeight: '600' }}>
                            {a.donusum_orani}%
                          </span>
                        </td>
                        <td style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280' }}>{a.ort_hiring_suresi > 0 ? a.ort_hiring_suresi + ' gun' : '-'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Müşteri Bazlı */}
      {aktifSekme === 'musteri' && (
        <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
          {musteri_ozet.length === 0 ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: '#6B7280' }}>Veri bulunamadi</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Musteri</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Toplam Aday</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Tamamlanan</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Elenen</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Donusum %</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Ort. Hiring</th>
                  </tr>
                </thead>
                <tbody>
                  {musteri_ozet.map((m, i) => (
                    <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                      <td style={{ padding: '10px 16px', fontWeight: '500' }}>{m.musteri}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right' }}>{m.toplam}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', color: '#059669', fontWeight: '600' }}>{m.tamamlanan}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', color: '#DC2626' }}>{m.elenen}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right' }}>
                        <span style={{ background: m.donusum_orani >= 30 ? '#D1FAE5' : '#FEF3C7', color: m.donusum_orani >= 30 ? '#059669' : '#D97706', padding: '2px 8px', borderRadius: '99px', fontSize: '12px', fontWeight: '600' }}>
                          {m.donusum_orani}%
                        </span>
                      </td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280' }}>{m.ort_hiring_suresi > 0 ? m.ort_hiring_suresi + ' gun' : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Aday Listesi */}
      {aktifSekme === 'adaylar' && (
        <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
          {adaylar.length === 0 ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: '#6B7280' }}>Aday bulunamadi</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Aday</th>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Musteri</th>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Pozisyon</th>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Telefon</th>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Musteri Gor.</th>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Teklif</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Hiring</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Tarih</th>
                  </tr>
                </thead>
                <tbody>
                  {adaylar.map((a, i) => {
                    const durumRenk = (d, pozitif, negatif) => ({
                      bg: d === pozitif ? '#D1FAE5' : d === negatif ? '#FEE2E2' : '#F3F4F6',
                      text: d === pozitif ? '#059669' : d === negatif ? '#DC2626' : '#6B7280',
                    });
                    const telRenk = durumRenk(a.telefon_durumu, 'gecti', 'elendi');
                    const musRenk = durumRenk(a.musteri_durumu, 'gecti', 'elendi');
                    const tekRenk = durumRenk(a.teklif_durumu, 'evraklar_yuklendi', 'reddedildi');
                    return (
                      <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                        <td style={{ padding: '10px 16px', fontWeight: '500' }}>{a.ad} {a.soyad}</td>
                        <td style={{ padding: '10px 16px', color: '#6B7280' }}>{a.basvuru_musteri || '-'}</td>
                        <td style={{ padding: '10px 16px', color: '#6B7280' }}>{a.basvuru_pozisyon || '-'}</td>
                        <td style={{ padding: '10px 16px' }}>
                          <span style={{ background: telRenk.bg, color: telRenk.text, padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>{a.telefon_durumu || '-'}</span>
                        </td>
                        <td style={{ padding: '10px 16px' }}>
                          <span style={{ background: musRenk.bg, color: musRenk.text, padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>{a.musteri_durumu || '-'}</span>
                        </td>
                        <td style={{ padding: '10px 16px' }}>
                          <span style={{ background: tekRenk.bg, color: tekRenk.text, padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>{a.teklif_durumu || '-'}</span>
                        </td>
                        <td style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280' }}>{a.hiring_suresi_gun ? a.hiring_suresi_gun + ' gun' : '-'}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'right', color: '#9CA3AF', fontSize: '12px' }}>{fmtTarih(a.olusturma_tarihi)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default IsealimRaporuPage;
